// import { SheetDependencies } from './references';

import { NumberFormat } from './numberFormat';
import { Dependency } from './refs';

// export enum CellContentTypes {
//   Rich_Text = 'RICH_TEXT',
//   Formula = 'FORMULA',
//   Number = 'NUMBER',
//   Date = 'DATE',
//   Files = 'FILES',
// }

export enum CellErrors {
  ERROR = '#ERROR!',
  REF = '#REF!',
}

// interface CellHistory
//   extends Pick<CellContents, 'value' | 'editedBy' | 'editedOn'> {}

// export interface CellContents {
//   value: string | number | boolean;
//   editedBy: string; // username
//   valueType: CellValueType;
//   editedOn: string;
//   history: Partial<CellHistory>[];
//   // result: string | number;
//   // dependencies: SheetDependencies;
//   // independencies: SheetDependencies;

//   // conditionalFormatKeys: string[],
//   // editOn: Date,
//   // fileSupportEnabled: boolean,
// }

export interface CellHistory {
  v: string; // Value
  u: string; // userId
  t: number; // Timestamp
}

interface CellError {
  type: CellErrors;
  details: string;
}

// export enum CellValueType {
//   String = 1,
//   Number = 2,
//   Date = 3,
//   Boolean = 4,
//   Formula = 5,
// }

export type CellValue = string | number | boolean;

export interface CellInterface {
  v: CellValue; // value
  r: CellValue; // result
  h: CellHistory[]; // history
  // d: Dependency[]; // Dependency
  // i: Independency[]; // Independency
  // dF: NumberFormat; // Dependent Formats
}

export type Cell = Partial<CellInterface>;

export type Cells = Cell[][];

// export type Cells = Cell[][];
// export type CellsHistory = CellHistory[][][]; // Limited history for cells

// export type Result = Cell | CellError;
// export type Results = Result[][];

// export interface SheetCells {
//   cells: Cells
// }

// export type Cell = Partial<CellContents>;

// export interface RowCells {
//   [rowId: string]: Cell;
// }

// export interface ColCells {
//   [colId: string]: RowCells;
// }

// export type Result = string | number;

// export interface RowResults {
//   [rowId: string]: Result;
// }

// export interface ColResults {
//   [colId: string]: RowResults;
// }

// export interface RowFormatIds {
//   [rowId: string]: string;
// }

// export interface ColFormatIds {
//   [colId: string]: RowFormatIds;
// }
